import { XIcon } from '@/icons';
import { Button, Flex, Modal, type ModalProps } from 'antd';
import type { ReactNode } from 'react';
import { cn } from '../lib/cn';
// import CustomTitle from "./CustomTitle";

export interface CustomModalProps extends ModalProps {
  open: boolean;
  size?: number;
  title?: string;
  subTitle?: string;
  description?: string;
  centered?: boolean;
  className?: string;
  children?: ReactNode;
  titleRender?: ReactNode;
  handleClose: () => void;
  disableCloseButton?: boolean;
}

const CustomModal = ({
  open = false,
  size = 360,
  title,
  // description,
  children,
  className,
  titleRender,
  handleClose,
  centered = true,
  closable = true,
  ...rest
}: CustomModalProps) => {
  return (
    <Modal
      open={open}
      width={size}
      footer={null}
      closable={false}
      centered={centered}
      className={cn('custom-modal', className)}
      onCancel={() => closable && handleClose()}
      rootClassName="custom-bg-modal"
      title={
        titleRender ? (
          titleRender
        ) : (
          <Flex justify="space-between">
            {/* <CustomTitle.Title title={title || ""} description={description} /> */}
            <div className="justify-start text-white text-2xl font-normal">
              {title}
            </div>
            {!!closable && (
              <Button
                size="small"
                color="default"
                variant="text"
                className="rounded shrink-0"
                icon={<XIcon className="text-xl" />}
                classNames={{ icon: 'flex items-center justify-center' }}
                onClick={() => closable && handleClose()}
              />
            )}
          </Flex>
        )
      }
      {...rest}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
